import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14 12v.01","key":"svg-0"}],["path",{"d":"M3 21h18","key":"svg-1"}],["path",{"d":"M6 21v-16a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v16","key":"svg-2"}]]

const IconDoor = createReactComponent('outline', 'door', 'Door', __iconNode);

export default IconDoor;